<template>
  <div class="dialog-ai" :class="{ fullscreen: isFullScreen }">
    <iframe
      width="100%"
      height="100%"
      :src="`${hostPort}/dseAiRobot/home`"
      frameborder="0"
    ></iframe>
  </div>
</template>
<script>
import { getCurrentHostPort } from '@/utils/index.js'

export default {
  name: 'DialogAi',
  props: {
    isFullScreen: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      hostPort: getCurrentHostPort()
    }
  },
}
</script>
<style scoped lang="scss">
.dialog-ai {
  position: fixed;
  top: 50%;
  right: 0;
  transform: translateY(-50%);
  width: 432px;
  height: 640px;
  z-index: 1000;
}
.fullscreen {
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  transform: translateY(0);
  z-index: 9999;
}
</style>
